<template>
  <v-row>
    <v-col cols="6" sm="12" lg="6">
      <p class="ok-title">{{ $t('paid') }}</p>
      <p class="ok-subtitle small" v-if="hasActivePaymentPlan">{{ debt.paymentPlan.summary.totalPaid | currency}}</p>
      <p class="ok-subtitle small" v-else>{{ debt.debtSummary.totalPaid | currency}}</p>
    </v-col>
    <template v-if="!isJointPaymentPlan">
      <v-col cols="6" sm="12" lg="6">
        <p class="ok-title">{{ $t('creditor') }}</p>
        <p class="ok-subtitle small">{{ debt.creditor.name }}</p>
      </v-col>
      <v-col cols="6" sm="12" lg="6">
        <p class="ok-title">{{ $t('debt') }}</p>
        <p class="ok-subtitle small" data-matomo-mask>{{ debt.orderNr }}</p>
      </v-col>
      <v-col cols="6" sm="12" lg="6">
        <p class="ok-title">{{ $t('paymentReceiver') }}</p>
        <p class="ok-subtitle small">B2 Impact</p>
      </v-col>
      <v-col cols="6" sm="12" lg="6">
        <p class="ok-title">{{ $t('sds-text-2') }}</p>
        <p class="ok-subtitle small">
          <v-icon small :class="'mr-1 debt-state state-' + debt.debtSummary.state.colorGroup">fas fa-circle</v-icon>
          {{ $t('state.' + debt.debtSummary.state.state) }}
        </p>
      </v-col>
      <v-col cols="6" sm="12" lg="6" v-if="debt.bills.length > 0 && debt.bills[0].claimType != null">
        <p class="ok-title">{{ $t('receivable') }}</p>
        <p class="ok-subtitle small">{{ $t('claimType.' + debt.bills[0].claimType) }}</p>
      </v-col>
      <v-col cols="6" sm="12" lg="6" v-if="debt.originalCreditor && debt.originalCreditor !== ''">
        <p class="ok-title">{{ $t('sds-text-3') }}</p>
        <p class="ok-subtitle small">{{debt.originalCreditor}}</p>
      </v-col>
      <v-col cols="12" v-if="debt.othersInvolved.length > 0">
        <p class="ok-title">{{ $t('partDebtors') }}</p>
        <p class="ok-subtitle small" v-for="(partDebtor, i) in debt.othersInvolved" :key="i">{{partDebtor.name}}</p>
      </v-col>
      <template v-if="debt.debtSummary.state.state === 6">
        <v-col cols="6" sm="12" lg="6" v-if="debt.debtReliefTotalSum !== null">
          <p class="ok-title">{{ $t('debtReliefTotalSum') }}</p>
          <p class="ok-subtitle small">{{debt.debtReliefTotalSum | currency}}</p>
        </v-col>
        <v-col cols="6" sm="12" lg="6" v-if="debt.orderDebtRestructuringDebtID !== null">
          <p class="ok-title">{{ $t('orderDebtRestructuringDebtID') }}</p>
          <p class="ok-subtitle small">{{debt.orderDebtRestructuringDebtID}}</p>
        </v-col>
      </template>
      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <shared-balance-report :debtNr="debt.nr"></shared-balance-report>
      </v-col>
    </template>
    <template v-if="$vuetify.breakpoint.mdAndUp && !disableReports">
      <v-col cols="12" v-if="hasActivePaymentPlan">
        <shared-reconciliation-report :link=false :msnr="debt.paymentPlan.nr" v-if="debt.paymentPlan.paymentPlanType === 7"></shared-reconciliation-report>
        <shared-payment-plan-report :msnr="debt.paymentPlan.nr" v-else></shared-payment-plan-report>
      </v-col>
      <v-col cols="12" v-if="debt.isVerdictAvailable">
        <verdict-dialog :debtNr="debt.nr" :modal="false"></verdict-dialog>
      </v-col>
    </template>
  </v-row>
</template>

<script>
  import VerdictDialog from '../../Verdict/Verdict.vue'

  export default {
    props: ['debt'],
    data: function () {
      return {
        wheelSize: 200,
        wheelWidth: 15
      }
    },
    computed: {
      disableReports () {
        return this.debt.hidePersonalInfo
      },
      hasActivePaymentPlan () {
        return this.debt.paymentPlan !== null
      },
      isJointPaymentPlan () {
        return this.hasActivePaymentPlan && this.debt.paymentPlan.isJointPaymentPlan
      },
      nextInstallment () {
        return this.debt.paymentPlan.nextInstallment
      }
    },
    components: {
      'verdict-dialog': VerdictDialog
    }
  }
</script>

<i18n>
  {
  "fi": {
  "sds-text-2": "Velan tila",
  "sds-text-3": "Alkuperäinen velkoja"
  },
  "se": {
  "sds-text-2": "Skuld status",
  "sds-text-3": "Ursprunglig fordringsägare"
  },
  "en": {
  "sds-text-2": "Debt status",
  "sds-text-3": "Original creditor"
  }
  }
</i18n>
